<template>
  <div class="appraiseTaskTemplate">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" center>
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">人员评估</el-menu-item>
        <el-menu-item index="2">操作评估</el-menu-item>
      </el-menu>
      <div class="menu1" v-if="activeIndex === '1'">
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="复选框 A"></el-checkbox>
          <el-checkbox label="复选框 B"></el-checkbox>
          <el-checkbox label="复选框 C"></el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="menu2">

      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        title: '自定义评估模板',
        activeIndex: '1',
        checkList: ['复选框 A']
      }
    },
    methods: {
      handleSelect(val) {
        console.log(val)
      }
    }
  }
</script>

<style lang="less" scoped>
  .appraiseTaskTemplate {
    .el-dialog__body {
      padding: 0px 20px 40px 0px;

      .menu1 {
        margin-left: 20px;
        margin-top: 20px;

        .el-checkbox {
          margin-top: 10px;
        }
      }
    }
  }
</style>
